import { getGridContextMenuList } from "../../../_helpers/getGridContextMenuList";
import { formatDate } from "../../../_helpers";
import { LabelColumnV2 } from "../../../components/DataGridV2/DataColumnsV2";
import { LOCAL_STORAGE_GRID_KEYS } from "../../../_constants";

export const getBuildingListForGenerationColumns = ({
  t,
  i18n,
  apiRef,
  keyPrefix,
}) => {
  const getOptions = getGridContextMenuList({
    filterKey: LOCAL_STORAGE_GRID_KEYS.BUILDING_LIST_FOR_GENERATION_COLUMN_FILTER[keyPrefix],
    sortKey: LOCAL_STORAGE_GRID_KEYS.BUILDING_LIST_FOR_GENERATION_COLUMN_SORT[keyPrefix],
    i18n,
    t,
    apiRef,
    getValueForCopy: (rowData, extraData) => {
      let text = ""
      switch (extraData.fieldName) {
         case "startDateTime":
          text = rowData.startDateTime ?  formatDate(new Date(rowData.startDateTime), true) : ''
          break;
        case "endDateTime":
          text = rowData.endDateTime ?  formatDate(new Date(rowData.endDateTime), true) : ""
          break;
        default:
          text = rowData[extraData.fieldName]
          break;
      }
      return text
    },
    mode: "client"
  })
  return [
    {
      field: "buildingNoIntern",
      headerName: t("general.buildingNumber"),
      flex: 1,
      sortable: 'true',
      download: true,
      renderCell: (params) => {
        const rowData = params.row;
        return (
          <LabelColumnV2
            label={rowData.buildingNoIntern}
            cellSubMenuOptions={{ options: getOptions({ field: "buildingNoIntern", isQuickFilterDisplay: rowData?.buildingNoIntern }), extraData: { fieldName: "buildingNoIntern", } }}
            request={rowData}
          />
        );
      },
    },
    {
      field: "projectNo",
      headerName: t("general.projectNumber"),
      flex: 1,
      minWidth: 90,
      download: true,
      renderCell: (params) => {
        const rowData = params.row;
        return <LabelColumnV2
          label={rowData.projectNo}
          cellSubMenuOptions={{ options: getOptions({ field: "projectNo", isQuickFilterDisplay: rowData?.projectNo }), extraData: { fieldName: "projectNo", } }}
          request={rowData}
        />
      },
    },
    {
      field: "projectName",
      headerName: t("general.projectName"),
      flex: 1,
      minWidth: 90,
      download: true,
      renderCell: (params) => {
        const rowData = params.row;
        return <LabelColumnV2
          label={rowData.projectName}
          cellSubMenuOptions={{ options: getOptions({ field: "projectName", isQuickFilterDisplay: rowData?.projectName }), extraData: { fieldName: "projectName", } }}
          request={rowData}
        />
      },
    },
    {
      field: "status",
      headerName: t("general.status"),
      flex: 1,
      minWidth: 90,
      download: true,
      renderCell: (params) => {
        const rowData = params.row;
        return <LabelColumnV2
          label={rowData.status}
          cellSubMenuOptions={{ options: getOptions({ field: "status", isQuickFilterDisplay: rowData?.status }), extraData: { fieldName: "status", } }}
          request={rowData}
        />
      },
    },
    {
      field: "buildingType",
      headerName: t("general.buildingType"),
      flex: 1,
      minWidth: 90,
      download: true,
      renderCell: (params) => {
        const rowData = params.row;
        return <LabelColumnV2
          label={rowData.buildingType}
          cellSubMenuOptions={{ options: getOptions({ field: "buildingType", isQuickFilterDisplay: rowData?.buildingType }), extraData: { fieldName: "buildingType", } }}
          request={rowData}
        />
      },
    },
    {
      field: "buyerRenterName",
      headerName: t("general.buyerRenterName"),
      flex: 1,
      minWidth: 90,
      download: true,
      renderCell: (params) => {
        const rowData = params.row;
        return <LabelColumnV2
          label={rowData.buyerRenterName}
          cellSubMenuOptions={{ options: getOptions({ field: "buyerRenterName", isQuickFilterDisplay: rowData?.buyerRenterName }), extraData: { fieldName: "buyerRenterName", } }}
          request={rowData}
        />
      },
    },
   {
      field: "startDateTime",
      headerName: t('general.startDate'),
      flex: 1,
      minWidth: 90,
      type: "dateTime",
      valueGetter: (params) => {
        if (!params) return "";
        return new Date(params);
      },
      download: true,
      renderCell: (params) => {
        const rowData = params.row;
        return <LabelColumnV2
          label={rowData.startDateTime}
          cellSubMenuOptions={{ options: getOptions({ field: "startDateTime", isQuickFilterDisplay: rowData?.startDateTime }), extraData: { fieldName: "startDateTime", type: "dateTime" } }}
          request={rowData}
        />
      },
    },
    {
      field: "endDateTime",
      headerName: t('general.endDate'),
      flex: 1,
      minWidth: 90,
      type: "dateTime",
      valueGetter: (params) => {
        if (!params) return "";
        return new Date(params);
      },
      download: true,
      renderCell: (params) => {
        const rowData = params.row;
        return <LabelColumnV2
          label={rowData.endDateTime}
          cellSubMenuOptions={{ options: getOptions({ field: "endDateTime", isQuickFilterDisplay: rowData?.endDateTime }), extraData: { fieldName: "endDateTime", type: "dateTime" } }}
          request={rowData}
        />
      },
    },
  ];
}


